export const getDate = (dateTime: string) =>
   dateTime.substring(0, 10).split('-').reverse().join('/');
